import { useState } from 'react'

import { StepperContext, type Steps } from './StepperContext'

type StepperProviderProps = {
  components: Steps
  initialStep: string
  children: React.ReactNode
}

export const StepperProvider = ({ components, initialStep, children }: StepperProviderProps) => {
  const [activeStep, setActiveStep] = useState<string>(initialStep)
  const ActiveComponent = components[activeStep]

  const goToStep = (step: keyof typeof components) => {
    if (!components[step]) throw new Error('Invalid step')
    setActiveStep(step)
  }

  return (
    <StepperContext.Provider value={{ goToStep, ActiveComponent, activeStep }}>
      {children}
    </StepperContext.Provider>
  )
}
